<template>
  <div class="w100 pagination-page" v-loading="loading">
    <div class="w100 accrual-head po-a">
      <div class="w120 mc font-40 pl10 page-name" style="padding-top: 83px;">{{title}}</div>
    </div>
    <div class="bg-ww pagination-container po-r bor-ra card-shadow">
      <div class="search-warp" v-if="this.type&&this.type != 'file'">
        <el-form :inline="true" label-width="80px"class="">
          <el-form-item label="部门"  style="min-width: 250px;">
            <el-input v-model="noticeSearch.deptName" placeholder="请输入部门名称">
            </el-input>

          </el-form-item>
          <el-form-item label="类型" >
            <el-select v-model="noticeSearch.noticeType" clearable placeholder="请选择">
              <el-option
                      v-for="item in noticeTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="名称" >
            <el-input v-model="noticeSearch.name"  placeholder="请输入关键词">
            </el-input>

          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="initList">查询</el-button>
            <el-button type="primary" @click="allReadFn">全部已读</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="search-warp" style="padding-left: 180px" v-if="this.type == 'file'">
        <el-form :inline="true" label-width="80px"class="">
          <el-form-item label="类型" >
            <el-select v-model="fileSearch.type" clearable  placeholder="请选择">
              <el-option
                      v-for="item in fileTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="名称" >
            <el-input v-model="fileSearch.keywords" placeholder="请输入关键词">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="initList">查询</el-button>
            <el-button type="primary" @click="allReadFn">全部已读</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div style="padding: 0px 180px 80px;" class="font-16">


        <p v-for="item in list" :key="item.id" class="flex-box ju-sb mt10 mb10 pl10 pr10 ellipsis cu-p pagination-item" @click="viewDetail(item)">
          <span class="flex-1 mr10 ellipsis">{{item.title || item.name || item.serveName}}</span>
          <span class="read-flag" :class="{'read-flag-did':item.readFlag==0}">{{item.readFlag | readFlagFilter}}</span>
          <span class="grey">{{item.createTime}}</span>
        </p>
      </div>
      <div class="mt20 flex-box po-a" style="bottom: 20px;right: 180px">
        <div class="flex-1"></div>
        <el-pagination
          background
          @current-change="changePage"
          :current-page="current"
          :page-size="size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {tableList,tabsList,tHallPolicyFileAllRead} from '@/api/portrayal/policy'
import { getUser } from "@/api/management/user";
import { stuAndteachStastic } from "@/api/home/home";
import {getNoticeList,allRead} from '@/api/managementCenter/notification'
import { remote } from '@/api/admin/dict';
import TreeSelect from "@/components/TreeSelect.vue";
import { getDeptTree} from '@/api/managementCenter/otherApi';
import { mapActions } from "vuex";
export default {
  name: "noticesAndFilesPagination",
  data() {
    return {
      loading: false,
      noticeTypeList:[],
        fileTypeList:[],
      departmentData:[],
      mapKey:{
          id:'id',// ID
          label: 'name',// 显示名称
          children: 'children', //子级字段名
      },
      noticeSearch:{
          deptName:'',
          noticeType:'',
          name:''
      },
        fileSearch:{
            type:'',
            keywords:''
        },
      list: [],

      current: 1,
      size: 20,
      total: 0,
      type: '',
      title: '',
    };
  },
  components: {
      TreeSelect
  },
  computed: {
  },
  watch: {},
  created() {
    this.type = this.$route.query.type
    this.title = this.type==='file'?'校内公文': this.type==='3' ? '规章制度' : this.type==='4' ? '业务流程' : this.type==='5' ?  '常用下载' : '通知公告'
    this.noticeSearch.noticeType = this.type == 'notice' ? '0' : this.type
    this.initList()
      this.remoteFn();
      if(this.type === 'file'){
          this.typeOption();
      }
  },
  methods: {
      ...mapActions(["GetUnreadCount"]),
    initList(){
      this.current = 1;
      this.getList()
    },
    getList(){
          if(this.type === 'business') {
              let type
              let userId = this.$store.getters.userData.userId
              getUser(userId).then(res =>{
                  type = res.data.data.type
                  stuAndteachStastic().then(res =>{
                      if(type == 1) {
                          this.list = res.data.data.teacher
                      }else {
                          this.list = res.data.data.stu
                      }
                  })
              })
          }
      const rq = this.type === 'file' ? tableList : getNoticeList;
      let pageSeahparams={
          current:this.current,
          size:this.size
      }
      let params =this.type === 'file' ? {...this.fileSearch,...pageSeahparams}:{...this.noticeSearch,...pageSeahparams};
      this.loading=true
      rq(params).then(({data}) => {
          this.loading=false
        if(data.code == 0){
          this.list = data.data.records;
          this.total = data.data.total;
        }else {
          this.$message.error(data.msg)
        }
      }).catch(err=>{
          this.loading=false
      })
    },
    changePage(page){
      this.current = page
      this.getList()
    },
    viewDetail(item){
      const path = this.type === 'file' ? '/fileDetail' : '/notifyDetail';
      let routeData = this.$router.resolve({
        name: path,
        query: {
          id: item.id,
          fileId:item.fileId||'',
          type:item.type||''
        }
      });
      window.open(routeData.href);
    },
    //获取类型
    remoteFn(){
        remote('notice_type').then(({data})=>{
            if(data.code == 0){
                this.noticeTypeList = data.data||[];
            }else{
                this.$message.warning( data.msg|| "获取类型失败!" );
            }
        }).catch(err=>{
            this.$message.error( data.msg|| "获取类型异常!" );
        })

    },
      //获取部门数据
      getDeptTreeData(){
          getDeptTree().then(({data})=>{
              if(data.code == 0){
                  if(data.data&&data.data.length>0) {
                      if(data.data[0].id==1){
                          this.departmentData = data.data[0].children;
                      }else{
                          this.departmentData = data.data
                      }
                  }
              }
          }).catch(err=>{

          })
      },
      setDeptSingleMenu(key,data){//获取子组件值
          this.noticeSearch.curDeptId = data.id;
      },
      allReadFn(){
        let method=null;
          if(this.type === 'notice'){
              method=allRead;
          }
          if(this.type === 'file'){
              method=tHallPolicyFileAllRead;
          }
          method().then(({data})=>{
              if(data.code == 0){
                  this.$message.success( "操作成功!" );
                  this.getList();
                  this.GetUnreadCount();
              }else{
                  this.$message.warning( data.msg|| "操作失败!" );
              }
          }).catch(err=>{
              this.$message.error( "服务异常!" );
          })
      },
      typeOption(){
          tabsList('/admin/dict/type/policy_type').then(res => {
              if (res.data.code == 0) {
                  this.fileTypeList=res.data.data||[];
              }
          })
      },

  },
    filters:{
        readFlagFilter(value){
            let obj={
                '0':'未读',
                '1':'已读',
            }
            return obj[value+'']||''

        }

    }
};
</script>

<style lang="less" scoped>
.pagination-container {
  min-height: calc(100vh - 260px);
  width: 1200px;
  margin: 100px auto 0;
  .pagination-item {
    line-height: 36px;
    &:hover {
      background: #fafafa;
    }
  }
}
  .search-warp{
    padding-top: 20px ;
    padding-left: 50px;
  }
  .read-flag{
    padding-right: 30px;
    color: #cccccc;
    cursor: initial;
    font-size: 12px;
    &.read-flag-did{
      color: rgba(64, 158, 255,0.7);
    }
  }
</style>
